import huiboBox from './method';
import { MD5encryption } from '@/utils/index';
import { cloneDeep } from 'lodash-es';
export const anyRequest = data => {
  if (data.method === 'GET') {
    let paramsArray: any[] = [];
    Object.keys(data.params).forEach(key =>
      paramsArray.push(key + '=' + encodeURIComponent(data.params[key]))
    );
    if (data.url.search(/\?/) === -1) {
      typeof data.params === 'object' ? (data.url += '?' + paramsArray.join('&')) : data.url;
    } else {
      data.url += '&' + paramsArray.join('&');
    }
  }
  const sconeTime = Math.floor(new Date().getTime() / 1000);
  const obj = cloneDeep(data.params !== '' ? data.params : {});
  const nonce = huiboBox.createUUID(16);
  const signParams = obj ? JSON.stringify(huiboBox.objSort(huiboBox.anyToString(obj))) : '{}';
  fetch(data.url, {
    method: data.method,
    headers: {
      'Content-Type': 'application/json',
      's-timestamp': sconeTime,
      's-nonce': nonce,
      's-sign': `${MD5encryption(`${nonce}${sconeTime}${signParams}`).toUpperCase()}`,
    },
  })
    .then(res => res.json())
    .then(resp => {
      data.callback(resp);
    });
};
